
import moment from 'moment';
import { Component, Mixins } from 'vue-property-decorator';
import { getCloudOrders } from '@/api/cloud_record_history';
import { PageQuery } from '@/mixins/page_query';
@Component({
  // filters: {
  //   local_time_str(val: number) {
  //     return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
  //   },
  // },
})
export default class extends Mixins(PageQuery) {
  private start!: any;
  private end!: any;
  private dataValue: (string | Date)[] = [];
  loading: boolean = false;
  total: number = 0;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  private payStus = '';
  private completedStas = 0;

  private tableData = [];
  private payTp = 0;
  paramsInfo = {
    start: 0,
    end: 0,
    user_name: '',
    user_id: '',
    order_no: '',
    act_id: '',
    act_name: '',
    page: 1,
    size: 30,
  };
  searchList() {
    this.getCloudOrders();
  }
  dataChange(datavalue: Date[]) {
    if (!datavalue) {
      this.paramsInfo.start = 0;
      this.paramsInfo.end = 0;
      this.paramsInfo.page = 1;
      this.getCloudOrders();
      return;
    }
    this.paramsInfo.start = Math.floor(datavalue[0].getTime() / 1000);
    this.paramsInfo.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.paramsInfo.page = 1;
    this.getCloudOrders();
  }
  handleSizeChange(size: number) {
    this.paramsInfo.size = size;
    this.paramsInfo.page = 1;
    this.getCloudOrders();
  }
  handleCurrentChange(page: number) {
    this.paramsInfo.page = page;
    this.getCloudOrders();
  }
  async getCloudOrders() {
    this.loading = true;
    const res = await getCloudOrders(this.paramsInfo);
    if (res && res.code == 0) {
      this.tableData = res.data.rows;
      this.total = res.data.count;
    }
    this.loading = false;
  }
  mounted() {
    this.getCloudOrders();
  }
}
